import { Message } from '../../../type';
import React from 'react';
import { TheirBalloon, TheirMessageContainer } from './TheirMessageContainer';
import { TextMessage } from '../by-type/TextMessage';
import { FileMessage } from '../by-type/FileMessage';
import { DeletedMessage } from '../by-type/DeletedMessage';
import { TheirMediaErrorMessage } from './TheirMediaErrorMessage';
import { MediaErrorMessageAware } from './MediaErrorMessageAware';

type TheirMessageProps = {
  message: Message;
  standalone?: boolean;
};

export const TheirMessage = React.forwardRef<HTMLLIElement, TheirMessageProps>(
  (props: TheirMessageProps, ref) => {
    const { message } = props;
    const {
      channelGuid,
      guid: messageGuid,
      messageType,
      mediaDeleted,
    } = props.message;
    const { scanStatus, fileName, url, thumbnailUrl } = message;
    return (
      <MediaErrorMessageAware
        error={() => (
          <TheirMediaErrorMessage
            key={message.guid}
            ref={ref}
            message={message}
          />
        )}
      >
        <TheirMessageContainer
          key={message.guid}
          ref={ref}
          message={message}
          standalone={props.standalone}
        >
          {() => {
            if (mediaDeleted) {
              return (
                <TheirBalloon>
                  <DeletedMessage message={message} />
                </TheirBalloon>
              );
            } else if (messageType === 'TEXT') {
              return (
                <TheirBalloon>
                  <TextMessage
                    content={props.message.content}
                    contentKey={props.message.contentKey}
                    contentParams={props.message.contentParams}
                    color='#3b4559'
                  />
                </TheirBalloon>
              );
            } else {
              const fileMessage = (
                <FileMessage
                  channelGuid={channelGuid}
                  messageGuid={messageGuid}
                  messageType={messageType}
                  local={false}
                  url={url}
                  thumbnailUrl={thumbnailUrl}
                  fileName={fileName}
                  scanStatus={scanStatus}
                />
              );
              if (messageType === 'PDF' || messageType === 'WORD') {
                return <TheirBalloon>{fileMessage}</TheirBalloon>;
              } else {
                return fileMessage;
              }
            }
          }}
        </TheirMessageContainer>
      </MediaErrorMessageAware>
    );
  },
);

TheirMessage.displayName = 'TheirMessage';
